import { render, staticRenderFns } from "./radish-quick-add.vue?vue&type=template&id=5c82fb0c&"
import script from "./radish-quick-add.vue?vue&type=script&lang=js&"
export * from "./radish-quick-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports